import { controller } from '../controller'
import { localStorageService } from '../../helpers'
export const pageHomeController = () => {
  const roles = localStorageService.getUserData()
  const obj = controller().checkRole(roles)
  return {
    asset: () => {
      const allowRoles = {
        systemadmin: true,
        admin: true,
        purchaser: true,
        tec: true,
        approver: true,
        user: false,
        risk: false,
        observer: false,
      }

      return controller().asset(allowRoles)
    },
    getMultiRole: () => {
      const { roleSingle, roles } = obj
      // console.log(obj)
      if (!roleSingle) {
        return roles
      }
    },
  }
}
